<template>
  <div
    :style="{
      'background-color':
        holderForm && holderForm.options.background_color
          ? holderForm.options.background_color
          : '#fff',
      padding: '0px',
    }"
  >
    <div class="webforms-content">
      <div v-if="!loading">
        <div
          v-if="holderForm"
          style="
            text-align: center;
          "
        >
          <div
            :style="{
              'background-color': '#fff',
              padding: '20px',
            }"
          >
            <img
              v-if="holderForm.logo"
              :src="holderForm.logo"
              :style="{
                'max-width': '250px',
                'max-height': '150px',
              }"
            />
            <div
              v-else
              :style="{
                'font-size': '30px',
                'margin-bottom': '15px',
              }"
            >
              {{ holderForm.name }}
            </div>
          </div>

          <div
            v-if="holderForm.options['introduce_' + getLang2Letters()]"
            :style="{
              'max-width': '700px',
              margin: '0 auto',
              color: holderForm.options.font_color,
              'margin-top': '20px',
              'text-align': 'justify',
              'white-space': 'pre-line',
              padding: '20px',
            }"
          >
            {{ holderForm.options["introduce_" + getLang2Letters()] }}
          </div>
        </div>
        <div
          :style="{
            display: 'flex',
            'justify-content': 'center',
            'margin-top': '20px',
          }"
        >
          <FormPage
            :style="{
              'max-width': '700px',
              width: '100%',
            }"
            :client="client"
            :form="form"
            @getform="getform"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BeFooter from "@/components/BeFooter.vue";
import FormPage from "./FormPage/index.vue";

export default {
  components: { BeFooter, FormPage },
  name: "WebForms",
  props: {
    msg: String,
    site_url: process.env.VUE_APP_SITE_URL,
  },

  data() {
    return {
      validating: true,
      success: false,
      error: false,
      data: {},
      loading: true,
      client: null,
      form: null,
      holderForm: null,
      localLanguage: "pt-BR",
    };
  },

  mounted() {
    const { query } = this.$route;
    let { language = "pt-BR" } = query;
    if('lang' in query) {
      language = query.lang
    }
    if(language == 'es') {
      language = 'esp'
    }
    switch (language.trim()) {
      case 'es':
        language = 'esp'
        break;
      case 'pt':
        language = 'pt-BR'
        break;
    }
    this.$i18n.locale = language;
    this.client = this.$route.params.client;
    this.form = this.$route.params.form;
    this.loading = false;
  },

  methods: {
    getLang2Letters() {
      return this.$i18n.locale.substring(0, 2);
    },
    getform(form) {
      if (form) {
        this.holderForm = form;
      }
    },
  },
};
</script>

<style scoped></style>
